// extracted by mini-css-extract-plugin
export default {"row":"Communication_row__lEVi_"};